const { PHRASE_TRANSLATIONS, REFERENCE_TIMEZONE } = process.env.REACT_APP_MARKET_VALUES;

const startWeekDay = {
    Monday: 0,
    Sunday: 1,
    Saturday: 2,
};

const convertTimezone = (date, timezoneString) => {
    return new Date(
        (typeof date === 'string' ? new Date(date) : date).toLocaleString('en-US', {
            timeZone: timezoneString,
        }),
    );
};

const sameDate = (d1, d2) =>
    new Date(new Date(d1).setHours(0, 0, 0, 0)).getTime() ===
    new Date(new Date(d2).setHours(0, 0, 0, 0)).getTime();

const isOpenToday = (currentTime, openHours) => {
    const openHoursFormat = /^\d{2}:\d{2} - \d{2}:\d{2}$/;

    // check if openHours are set to closed
    if (openHours === PHRASE_TRANSLATIONS.closed) return false;

    // check if the openHours match the correct format, otherwise return false
    if (!openHoursFormat.test(openHours)) return false;

    // turn the open and close times into decimal numbers
    let [startTime, endTime] = openHours.split('-');
    startTime = Number(startTime.replace(':', '.'));
    endTime = Number(endTime.replace(':', '.'));
    let time = currentTime;

    // adjust times to account for closures after midnight
    if (endTime < startTime) endTime += 24;
    if (time < startTime) time += 24;

    // If any of the values is not available, show contact center as clossed
    if (startTime === undefined || endTime === undefined) return false;

    // alculate if the contact method is closed
    if (time >= startTime && time <= endTime) return true;
    return false;
};

// Time formart converter
const convert24To12HoursFormat = (hours) => {
    const [hour, minutes] = hours.split(':');
    const amOrPm = parseInt(hour, 10) >= 12 ? 'PM' : 'AM';

    return `${hour % 12 || 12}:${minutes} ${amOrPm}`;
};

// returns the openeing hours in 12h time, with timezome for display if  indicated in the cms
// it does it for all the days of the week

const standarizedOpeningHours = (standardOpeningHours, timeZoneString) => {
    const {
        monOpen,
        monClose,
        tueOpen,
        tueClose,
        wedOpen,
        wedClose,
        thuOpen,
        thuClose,
        friOpen,
        friClose,
        satOpen,
        satClose,
        sunOpen,
        sunClose,
        timeFormat,
    } = standardOpeningHours;

    const is24HourFormat = timeFormat === '24-hour';
    // show clossed if monOpen / monClose values are not available
    return [
        `${
            monOpen && monClose
                ? `${is24HourFormat ? monOpen : convert24To12HoursFormat(monOpen)} - ${
                      is24HourFormat ? monClose : convert24To12HoursFormat(monClose)
                  }  ${timeZoneString}`
                : PHRASE_TRANSLATIONS.closed
        }`,
        `${
            tueOpen && tueClose
                ? `${is24HourFormat ? tueOpen : convert24To12HoursFormat(tueOpen)} - ${
                      is24HourFormat ? tueClose : convert24To12HoursFormat(tueClose)
                  }  ${timeZoneString}`
                : PHRASE_TRANSLATIONS.closed
        }`,
        `${
            wedOpen && wedClose
                ? `${is24HourFormat ? wedOpen : convert24To12HoursFormat(wedOpen)} - ${
                      is24HourFormat ? wedClose : convert24To12HoursFormat(wedClose)
                  }  ${timeZoneString}`
                : PHRASE_TRANSLATIONS.closed
        }`,
        `${
            thuOpen && thuClose
                ? `${is24HourFormat ? thuOpen : convert24To12HoursFormat(thuOpen)} - ${
                      is24HourFormat ? thuClose : convert24To12HoursFormat(thuClose)
                  }  ${timeZoneString}`
                : PHRASE_TRANSLATIONS.closed
        }`,
        `${
            friOpen && friClose
                ? `${is24HourFormat ? friOpen : convert24To12HoursFormat(friOpen)} - ${
                      is24HourFormat ? friClose : convert24To12HoursFormat(friClose)
                  }  ${timeZoneString}`
                : PHRASE_TRANSLATIONS.closed
        }`,
        `${
            satOpen && satClose
                ? `${is24HourFormat ? satOpen : convert24To12HoursFormat(satOpen)} - ${
                      is24HourFormat ? satClose : convert24To12HoursFormat(satClose)
                  }  ${timeZoneString}`
                : PHRASE_TRANSLATIONS.closed
        }`,
        `${
            sunOpen && sunClose
                ? `${is24HourFormat ? sunOpen : convert24To12HoursFormat(sunOpen)} - ${
                      is24HourFormat ? sunClose : convert24To12HoursFormat(sunClose)
                  } ${timeZoneString}`
                : PHRASE_TRANSLATIONS.closed
        }`,
    ];
};

const sortedStandarizedOpeningHours = (openingHours, firstDayOfWeek) => [
    ...openingHours.slice(openingHours.length - startWeekDay[firstDayOfWeek]),
    ...openingHours.slice(0, openingHours.length - startWeekDay[firstDayOfWeek]),
];

// convert holiday time form 24h  to 12h  time
const standarizedHolidays = (holidays, timeFormat, timeZoneString) => {
    const is12HoursFormat = timeFormat !== '24-hour';

    return holidays.map((holiday) => {
        const { openingTime, closingTime } = holiday;
        return {
            ...holiday,
            openingTime:
                openingTime && is12HoursFormat
                    ? convert24To12HoursFormat(openingTime)
                    : openingTime,
            closingTime:
                closingTime && is12HoursFormat
                    ? `${convert24To12HoursFormat(closingTime)} ${timeZoneString}`
                    : `${closingTime} ${timeZoneString}`,
        };
    });
};

//  standardOpeningHours => comes from the CMS
//  holidays => comes from the CMS

const standardOpeningHoursCMS = (standardOpeningHours, holidays) => {
    const {
        firstDayOfWeek,
        monOpen,
        monClose,
        tueOpen,
        tueClose,
        wedOpen,
        wedClose,
        thuOpen,
        thuClose,
        friOpen,
        friClose,
        satOpen,
        satClose,
        sunOpen,
        sunClose,
        timeZone,
        timeFormat,
    } = standardOpeningHours;

    let afterHoursMessage;
    let afterHoursInline;
    let afterHoursAvailability;
    const headline = PHRASE_TRANSLATIONS.inlineMessageHead;
    const message = PHRASE_TRANSLATIONS.inlineMessageBody;
    const timeZoneString = timeZone && timeZone.trim() !== '' ? `(${timeZone})` : '';
    const week = [
        PHRASE_TRANSLATIONS.monday,
        PHRASE_TRANSLATIONS.tuesday,
        PHRASE_TRANSLATIONS.wednesday,
        PHRASE_TRANSLATIONS.thursday,
        PHRASE_TRANSLATIONS.friday,
        PHRASE_TRANSLATIONS.saturday,
        PHRASE_TRANSLATIONS.sunday,
    ];

    // If any of the components is not available, it is assumed that on that day the markek is
    // closed/or store is not opened
    const openingHours = [
        `${monOpen && monClose ? `${monOpen} - ${monClose}` : PHRASE_TRANSLATIONS.closed}`,
        `${tueOpen && tueClose ? `${tueOpen} - ${tueClose}` : PHRASE_TRANSLATIONS.closed}`,
        `${wedOpen && wedClose ? `${wedOpen} - ${wedClose}` : PHRASE_TRANSLATIONS.closed}`,
        `${thuOpen && thuClose ? `${thuOpen} - ${thuClose}` : PHRASE_TRANSLATIONS.closed}`,
        `${friOpen && friClose ? `${friOpen} - ${friClose}` : PHRASE_TRANSLATIONS.closed}`,
        `${satOpen && satClose ? `${satOpen} - ${satClose}` : PHRASE_TRANSLATIONS.closed}`,
        `${sunOpen && sunClose ? `${sunOpen} - ${sunClose}` : PHRASE_TRANSLATIONS.closed}`,
    ];

    // Adjust standard week to match the specific starting day of the week indicated in the CMS by the markets
    // Monday => 0,  Sunday => 1, Saturday => 2,
    // The speard operator is used to rearrange the days of the week after adjustments
    const sortedWeek = [
        ...week.slice(week.length - startWeekDay[firstDayOfWeek]),
        ...week.slice(0, week.length - startWeekDay[firstDayOfWeek]),
    ];

    // Check if timezone exixts if not, throw an error
    if (!REFERENCE_TIMEZONE) {
        throw new Error('Missing  required  REFERENCE_TIMEZONE value');
    }
    const marketDate = convertTimezone(new Date(), REFERENCE_TIMEZONE);

    // Calculate market/store holidays for the next 30 days
    // Add 30 days to curent date to identify when it starts
    // Uses the current day and reference and returns the next holiday
    const marketDateIn30Days = new Date(new Date().setDate(marketDate.getDate() + 30));

    // Get the holidays set by the market in the next 30 days
    // Sort the resuklst of the filter from first to last
    const holidaysInTheNext30Days = holidays
        ? holidays
              .filter(
                  (holiday) =>
                      new Date(new Date(holiday.date).setHours(0.1)) < marketDateIn30Days &&
                      new Date(new Date(holiday.date).setHours(24)) >= marketDate,
              )
              .sort((a, b) => new Date(a.date) - new Date(b.date))
        : [];

    // Returns true if the dates match
    const todayIsHoliday = holidaysInTheNext30Days?.some((holiday) =>
        sameDate(new Date(holiday.date), marketDate),
    );

    const currentTime = Number(`${marketDate.getHours()}.${marketDate.getMinutes()}`);
    const currentDay = marketDate.getDay() === 0 ? 6 : marketDate.getDay() - 1;

    const todayHolidayHours = () => {
        if (todayIsHoliday) {
            const todayHoliday = holidaysInTheNext30Days?.find((holiday) =>
                sameDate(holiday.date, marketDate),
            );

            // Missing logic (it does not take into account the am/pm  ) by defauklt it uses the 24 hour time
            // Returns a string contining the specific opening/ clossing times for the spesific holiday date
            return `${
                todayHoliday.openingTime && todayHoliday.closingTime
                    ? `${todayHoliday.openingTime} - ${todayHoliday.closingTime}`
                    : PHRASE_TRANSLATIONS.closed
            }`;
        }
        return null;
    };

    const holidayOpeningHours = (hours, format) => {
        let openHours = '';
        const [openingTime, closingTime] = hours.split('-');
        if (format === '24-hour') openHours = hours;
        else
            openHours = `${convert24To12HoursFormat(openingTime)} - ${convert24To12HoursFormat(
                closingTime,
            )} ${timeZoneString}`;

        return openHours;
    };

    const availableHours = todayHolidayHours() || openingHours[currentDay];
    if (isOpenToday(currentTime, availableHours)) {
        afterHoursAvailability = 'open';
        if (todayIsHoliday)
            afterHoursMessage = `${PHRASE_TRANSLATIONS.hoursOpen} ${holidayOpeningHours(
                availableHours,
                timeFormat,
            )}`;
        else
            afterHoursMessage = `${PHRASE_TRANSLATIONS.hoursOpen} ${
                standarizedOpeningHours(standardOpeningHours, timeZoneString)[currentDay]
            }`;
    } else {
        afterHoursMessage = PHRASE_TRANSLATIONS.hoursClosed; // Checkand delete if not  needed/used
        afterHoursAvailability = 'closed'; // Value used to display the customer service center clossed message box

        // Check and remove if not used
        afterHoursInline = {
            headline,
            message,
        };
    }

    const hoursCMS = {
        weekDay: sortedWeek,
        standarizedOpeningHours: sortedStandarizedOpeningHours(
            standarizedOpeningHours(standardOpeningHours, timeZoneString),
            firstDayOfWeek,
        ),
        afterHoursAvailability,
        afterHoursMessage,
        afterHoursInline,
        holidays: standarizedHolidays(holidaysInTheNext30Days, timeFormat, timeZoneString),
    };
    return hoursCMS;
};

export default standardOpeningHoursCMS;
